import styled from 'styled-components';

export const Divider = styled.div`
  border-top: 1px solid #cccccc;
  width: 100%;
`;

export const DividerWrapper = styled.div<{ maxWidth?: string; padding?: string }>`
  margin: 0 auto;
  max-width: ${props => (props.maxWidth ? props.maxWidth : '100%')};
  padding: ${props => (props.padding ? props.padding : '1em 0')};
  text-align: center;
`;
